import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { OrganizationApi } from '../../../api';
import { CurrencyDto } from '../../../commonTypes/organization.types';

const useHttpGetCurrencies = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [data, setData] = useState<CurrencyDto[]>([]);
    const [isReady, setIsReady] = useState(false);

    const { exec, abort } = organizationApi.getCurrencies({
        onSuccess: res => setData(res.body),
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);
    return { isReady, data };
};

export default useHttpGetCurrencies;
